/* eslint-disable no-undef */
import $ from "jquery";

const removeproduct = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-remove-product-minicart",
      counterEl: ".js-counter-cart",
      minicart: ".js-minicart",
    };

    if ($(el.minicart).length === 0) return;

    // open popup in minicart components
    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      const key = $(this).data("key");
      const productId = $(`#${key}`).val();

      $.ajax({
        type: "POST",
        dataType: "json",
        url: themeObj.ajaxUrl,
        data: {
          action: themeObj.removeItemCart.action,
          nonce: themeObj.removeItemCart.nonce,
          product_id: productId,
        },
        beforeSend() {},
        success(response) {
          const counter = response.data.count;
          const html = response.data.html;
          $(el.counterEl).text(counter);
          $(el.minicart).html(html);
        },
        error() {},
        complete() {},
      });
    });
  };

  init();
};

try {
  removeproduct();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
